const initialState = {
    products: [],
    
};
const products = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_PRODUCTS':
           return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default products;
